import {useMutation} from '@tanstack/react-query';
import raiseFlashMessage from '@/utils/raiseFlashMessage';
import translate from '@/utils/translate';
import campaignUpdaters from '@/api/updaters/campaign';

interface UseCloseCampaignOptions {
  onSuccess?: () => void;
  onError?: () => void;
}

function useCloseCampaign({onSuccess, onError}: UseCloseCampaignOptions = {}) {
  return useMutation({
    mutationFn: (campaignId: string) =>
      campaignUpdaters.closeCampaign(campaignId),

    onSuccess: () => {
      onSuccess?.();
    },

    onError: () => {
      raiseFlashMessage({
        status: 'error',
        message: translate('Failed to close campaign. Please try again.'),
      });
      onError?.();
    },

    // NOTE: intentionally no campaignsV2List invalidation here. Refetching the
    // moment close resolves drops the (now-closed) campaign off the Live tab,
    // unmounting the card + this feedback modal mid-flow. The caller
    // invalidates once the whole close→feedback flow has finished instead.
  });
}

export default useCloseCampaign;
